import { ActionBase } from '../../../core/store/action/ActionBase';

export const GROUP_RULE_CONDITIONS_SUCCESS = '[DynamicDataSet] Group Rule Conditions Success';

export class GroupRuleConditionsSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GROUP_RULE_CONDITIONS_SUCCESS;

  constructor(public payload: { dynamicDataSetKey: string, dynamicRuleKey: string, groupName: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/GroupRuleConditionsSuccessAction.ts